import React, { useEffect, useState } from "react";
import CustomInput from "../../components/CustomInput";
import { IS_LOCAL_ENV } from "../../App";
import {
  createIgPost,
  deleteIgPost,
  updateIgPost,
} from "../../services/ecommerceElements";
import Notification from "../../components/ui-elements/Notification";

const IgCard = ({ prevData, uploadToParent, removeFromParent }) => {
  const [globalId, setGlobalId] = useState("ig-post-id");
  useEffect(() => {
    if (prevData) {
      setGlobalId((prev) => `${prev}_${prevData.id}`);
    }
  }, []);

  const [formData, setFormData] = useState({
    url: prevData?.url || "",
    isVideo: prevData?.isVideo || false,
  });

  const [fetching, setFetching] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.url.trim() == "") {
      Notification({
        title: "Error",
        text: "La URL no puede estar vacía",
        type: "Error",
      });
      return;
    }
    setFetching(true);
    const uploadData = async () => {
      try {
        let newPostObj = null;
        if (prevData) {
          newPostObj = await updateIgPost(prevData.id, formData);
        } else {
          newPostObj = await createIgPost(formData);
        }
        Notification({
          title: "Operación completada",
          text: `Se ${
            prevData ? "actualizó" : "creó"
          } la publicación de instagram con éxito`,
          type: "Success",
        });
        setFetching(false);
        !prevData && uploadToParent(newPostObj.doc);
      } catch (err) {
        IS_LOCAL_ENV && console.error(err);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        setFetching(false);
      }
    };
    uploadData();
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();
    setFetching(true);
    const deleteFetch = async () => {
      try {
        const { data } = await deleteIgPost(id);
        Notification({
          title: "Operación completada",
          text: `Se eliminó la publicación de instagram con éxito`,
          type: "Success",
        });
        setFetching(false);
        removeFromParent(prevData.id);
      } catch (err) {
        setFetching(false);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };
    deleteFetch();
  };

  return (
    <div className="min-w-[450px] flex flex-col p-4 rounded-xl border-[1px] border-accent-green gap-2 bg-white">
      <CustomInput
        title="URL"
        value={formData.url}
        onChange={(e) => setFormData({ ...formData, url: e.target.value })}
        placeholder="https://www.instagram.com/p/..."
        inputType="text"
        required={true}
      />
      <div className="flex flex-row gap-x-2 w-full items-center px-2">
        <input
          type="checkbox"
          id={globalId}
          checked={formData.isVideo}
          className="text-lg font-semibold"
          onChange={(e) =>
            setFormData({ ...formData, isVideo: e.target.checked })
          }
        />
        <label htmlFor={globalId} className="text-base font-semibold">
          Es video
        </label>
      </div>
      <div className="flex flex-row gap-x-2 w-full px-2 h-fit">
        <button
          disabled={fetching}
          type="submit"
          onClick={handleSubmit}
          className={` ${
            fetching
              ? "bg-light-gray cursor-not-allowed"
              : "bg-dark-green hover:bg-accent-green"
          }  w-full  text-base rounded-full py-2 px-6 text-white  transition-all duration-100 font-bold font-poppins`}
        >
          {prevData ? "Actualizar" : "Crear"}
        </button>
        {prevData && (
          <button
            disabled={fetching}
            className={`${
              fetching
                ? "bg-light-gray cursor-not-allowed"
                : "bg-red-600 hover:hover:bg-red-500"
            } w-full  text-base rounded-full py-2 px-6 text-white  transition-all duration-100 font-bold font-poppins`}
            onClick={(e) => (fetching ? null : handleDelete(e, prevData.id))}
          >
            Eliminar
          </button>
        )}
      </div>
    </div>
  );
};

export default IgCard;
